<template>
  <fieldset class="segmented-control" :aria-label="ariaLabel">
    <div
      v-for="segmentOption of options"
      :key="segmentOption.value"
      class="segmented-control__segment"
      :class="{
        'is-checked': segmentOption.value === modelValue,
        [$class('disabled')]: segmentOption.disabled,
      }"
    >
      <input
        :id="`${uniqueId}-${segmentOption.value}`"
        class="segmented-control__input"
        :checked="segmentOption.value === modelValue"
        :disabled="segmentOption.disabled"
        :name="name"
        type="radio"
        :value="segmentOption.value"
        @change="$emit('update:modelValue', segmentOption.value)"
      />
      <label
        class="segmented-control__label text-mobile-paragraph-s-bold text-desktop-paragraph-s-bold"
        :for="`${uniqueId}-${segmentOption.value}`"
        v-text="segmentOption.label"
      />
    </div>
  </fieldset>
</template>

<script>
/**
 * Vue: Segmented control (segmented-control)
 * -----------------------------------------------------------------------------
 * Small two (or more) way toggle rendered as native radio inputs styled as a
 * pill-shaped segmented control. Used for the PDP sweetness selector
 * (Normal / Less sweet).
 *
 * @param {String} ariaLabel - Accessible name for the control group.
 * @param {String} modelValue - Currently selected value.
 * @param {String} name - Radio input group name.
 * @param {Array<Object>} options - Segment options `{ value, label, disabled }`.
 *
 * @emits update:modelValue - Emit newly selected value.
 *
 */
export default {
  name: 'SegmentedControl',

  props: {
    ariaLabel: {
      type: String,
      default: '',
    },
    modelValue: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: () =>
        `segmented-control-${Math.random().toString(36).substring(2, 11)}`,
    },
    options: {
      type: Array,
      required: true,
    },
  },

  emits: {
    'update:modelValue': (value) => typeof value === 'string',
  },

  computed: {
    /**
     * Unique ID prefix for input/label pairs, namespaced by the group name.
     * @returns {String}
     */
    uniqueId() {
      return this.name;
    },
  },
};
</script>

<style lang="scss">
@import './segmented-control';
</style>
